import { ERoutes } from "../../constants/routes";

export const MENU_MAP: Partial<Record<ERoutes, string>> = {
  [ERoutes.Brands]: "Brands",
  [ERoutes.Overview]: "Overview",
  [ERoutes.PromptsHome]: "Prompts",
  [ERoutes.ModelsHome]: "Models",
  [ERoutes.Source]: "Source",
};

export const MENU = [
  ERoutes.Overview,
  ERoutes.Brands,
  ERoutes.PromptsHome,
  ERoutes.ModelsHome,
  ERoutes.Source,
];

export const MENU_WITH_NEW_BADGE = [ERoutes.Overview, ERoutes.Source];
